import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';
import api from '../../services/api/service';
import ProgressBar from './components/ProgressBar';
import { Container } from './styles';

//Images
import iconEmail from '../../config/images/iconEmail.png';

function SignUp({
  match: {
    params: { kind }
  },
  t,
  history,
  setTitle,
  currentStep,
  steps,
  data,
  setLoading,
  resetData,
  resetErrors,
  setCurrentStep
}) {
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    switch (kind) {
      case 'new':
        setTitle(t('signup.new'));
        break;

      default:
        history.push('/not-found');
        break;
    }

    return () => {
      resetErrors();
      resetData();
      setLoading(false);
      setCurrentStep(0, 'prev');
    };
  }, [history.location]);

  async function handleSubmit() {
    setLoading(true);

    const resp = await api.signup({ ...data, isNewOwner: kind === 'change' });

    if (resp.success) {
      setSubmitted(true);
    } else {
      setLoading(false);
    }

    setLoading(false);
  }

  if (submitted) {
    return (
      <div className="thank-you-container">
        <img className="mail-icon" src={iconEmail} alt="iconEmail"></img>
        <p className="title">
          <b>{t('form.thanksTitle')}</b>
        </p>
        <p className="information">{t('form.thanksNote')}</p>
        <p className="information">{t('form.thanksNoteContact')}</p>
      </div>
    );
  }

  return (
    <Container>
      <ProgressBar steps={steps} currentStep={currentStep} />

      {currentStep > 0 ? (
        <div className="text-center">
          <h3>{data.companyName}</h3>
          <p>{data.companyId}</p>
        </div>
      ) : null}

      {React.cloneElement(steps[currentStep].component, {
        kind,
        onSubmit: handleSubmit
      })}
    </Container>
  );
}

const mapStateToProps = state => ({
  data: state.signup.data,
  steps: state.signup.steps,
  currentStep: state.signup.currentStep
});

const mapDispatchToProps = dispatch => ({
  setTitle: title => dispatch({ type: 'SET_TITLE', payload: title }),
  setLoading: loading => dispatch({ type: 'SET_LOADING', payload: loading }),
  setCurrentStep: (step, dir) =>
    dispatch({ type: 'SET_CURRENT_STEP', payload: [step, dir] }),
  resetData: () => dispatch({ type: 'RESET_DATA' }),
  resetErrors: () => dispatch({ type: 'RESET_ERRORS' })
});

export default withNamespaces()(
  connect(mapStateToProps, mapDispatchToProps)(SignUp)
);
